export default {
  recharge: {
    success: {
      title: 'Sucesso ao realizar a compra do seu Recorrente!',
      text: 'O prazo para liberação do Recorrente é de até 24 horas',
    },
    error: {
      title: 'Compra não concluída',
      text: 'Tivemos um problema no processamento tente novamente',
    },
  },
  defaultError: {
    title: 'Ops',
    text: 'Tivemos um problema no processamento tente novamente',
  },
  edit: {
    success: {
      title: 'Alteração efetuada com sucesso!',
      text: '',
    },
    error: {
      title: 'Alteração não concluída',
      text: 'Tivemos um problema no processamento tente novamente',
    },
  },
  card: {
    error: {
      title: 'Ops',
      text: 'Tivemos um problema para cadastrar o seu cartão',
    },
  },
  phraseology: {
    welcome: {
      title: {
        subscribe: 'Compre o Recorrente e ganhe desconto',
        edit: '',
      },
      description: {
        subscribe:
          'Você economiza e tem mais praticidade: a renovação é automática todo mês e dá pra cancelar quando quiser',
        edit: '',
      },
    },
  },
  '4001': 'Este cartão está cadastrado em outra assinatura. Por favor, informar outro',
  '4002':
    'Transação Negada. Por favor, verifique os dados do seu cartão e tente novamente. Caso o erro persista, procure o emissor do seu cartão',
  '4004':
    'Não foi possível realizar esta adesão. Você já possui um Recorrente ativo para esta assinatura',
  '4005':
    'Ops, tivemos problemas ao processar o seu Recorrente. Por favor, tente novamente mais tarde',
  '4006':
    'Transação Negada. Por favor, verifique os dados do seu cartão e tente novamente. Caso o erro persista, procure o emissor do seu cartão',
  '4007':
    'Ops, tivemos problemas ao processar a compra do seu Recorrente. Por favor, tente novamente mais tarde',
  '4009': 'Cartão Inválido. Cartões aceitos: Visa, Mastercard, Elo ou Hipercard',
  '4010': 'Cartão Inválido. Por favor, verifique os dados do seu cartão e tente novamente',
  '4011': 'Cartão Vencido. Por favor, insira dados de um cartão válido',
  '4012':
    'Transação Negada. Por favor, verifique os dados do seu cartão e tente novamente. Caso o erro persista, procure o emissor do seu cartão',
  '4013':
    'Código de Segurança Informado inválido. Por favor, verifique os dados do seu cartão e tente novamente',
  '4014':
    'Assinatura em processo de cancelamento do serviço de Recarga Recorrente. Tente novamente mais tarde',
  '4016': 'Adesão em processamento, em instantes sua recarga será liberada',
  '5000':
    'Ops, tivemos problemas ao processar a sua Recarga Recorrente. Por favor, tente novamente mais tarde',
};
